'use client'

import { TreeunfeLogo } from '@/components/atoms/treeunfe-logo'
import { AuthMenu } from '@/components/organisms/auth-menu'
import { NavigationMenu } from '@/components/organisms/navigation-menu'
import { cn } from '@/lib/utils'
import { useEffect, useState } from 'react'

export const HeroHeader = () => {
  const [isScrolled, setIsScrolled] = useState<boolean | null>(null) // começa indefinido

  useEffect(() => {
    const checkScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    checkScroll()

    window.addEventListener('scroll', checkScroll)
    return () => window.removeEventListener('scroll', checkScroll)
  }, [])

  return (
    <header>
      <nav
        role="navigation"
        aria-label="Main navigation"
        className={cn(
          'fixed z-20 w-full px-1 transition-opacity duration-500',
          isScrolled === null ? 'opacity-0' : 'opacity-100',
        )}
      >
        <div
          className={cn(
            'mx-auto mt-2 max-w-[1240px] px-4 rounded-2xl transition-all duration-300 lg:px-12',
            isScrolled &&
              'bg-background/50 max-w-[1106px] border backdrop-blur-lg lg:px-5',
          )}
        >
          <div className="relative flex items-center justify-between gap-6 py-3 lg:gap-0 lg:py-4">
            <TreeunfeLogo href="/" />
            <div className="flex items-center justify-center flex-row-reverse lg:flex-row gap-2 lg:w-full">
              <NavigationMenu />
              <AuthMenu />
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}
